import { Alert, Button, Stack } from '@mui/material';
import { FeedbackSnackbar } from '../../../design-system';

type JobProfileNoticesProps = {
  canRead: boolean;
  familyError?: string;
  notice?: string;
  onRetryFamilies: () => void;
  onDismissNotice: () => void;
};

export function JobProfileNotices({
  canRead,
  familyError,
  notice,
  onRetryFamilies,
  onDismissNotice,
}: JobProfileNoticesProps) {
  if (canRead && !notice && !familyError) return null;
  return (
    <>
      <FeedbackSnackbar open={Boolean(notice)} message={notice} tone="success" onClose={onDismissNotice} />
      {(!canRead || familyError) && <Stack spacing={1.5} sx={{ mb: canRead ? 1.5 : 0, flexShrink: 0 }}>
        {!canRead ? <Alert severity="warning">직무 기준정보를 조회하려면 staffing.read 권한이 필요합니다.</Alert> : null}
        {familyError ? (
          <Alert
            severity="error"
            action={
              <Button color="inherit" size="small" onClick={onRetryFamilies}>
                다시 시도
              </Button>
            }
          >
            직군 목록을 불러오지 못해 직무 등록과 직군 필터를 사용할 수 없습니다.
          </Alert>
        ) : null}
      </Stack>}
    </>
  );
}
